import SampleMasterScreen from "components/modules/sample-module/masters/SampleMasterScreen";
import SampleMasterScreenTabbed from "components/modules/sample-module/masters/SampleMasterScreenTabbed";
import GoldRateMasterScreen from "components/modules/master-module/masters/GoldRateMasterScreen";
import CustomerRegistryScreen from "components/modules/customer-module/masters/CustomerRegistryScreen";
import SystemConfigScreen from "components/modules/utility-module/masters/SystemConfigScreen";
import AddonRequestScreen from "components/modules/addon-request-module/transactions/AddonRequestScreen";
import LoanMappingScreen from "components/modules/loan-mapping-module/transactions/LoanMappingScreen";
import ClosingTransactionScreen from "components/modules/closing-module/transactions/ClosingTransactionScreen";
import CombinedTransactionScreen from "components/modules/combined-module/transactions/CombinedTransactionScreen";
import GlReplacementScreen from "components/modules/gl-replacement-module/transactions/GlReplacementScreen";
import RegroupTransactionScreen from "components/modules/regroup-module/transactions/RegroupTransactionScreen";
import ApprovalDashboardScreen from "components/modules/approval-module/transactions/ApprovalDashboardScreen";
import ReportsPlaceholderScreen from "components/modules/reports-module/reports/ReportsPlaceholderScreen";
import AddonSummaryReportScreen from "components/modules/reports-module/reports/AddonSummaryReportScreen";
import LoanMappingReportScreen from "components/modules/reports-module/reports/LoanMappingReportScreen";
import ClosingSettlementReportScreen from "components/modules/reports-module/reports/ClosingSettlementReportScreen";
import CombinedTxnReportScreen from "components/modules/reports-module/reports/CombinedTxnReportScreen";
import AuditTrailReportScreen from "components/modules/reports-module/reports/AuditTrailReportScreen";
import GlReplacementReportScreen from "components/modules/reports-module/reports/GlReplacementReportScreen";
import GoldRateHistoryReportScreen from "components/modules/reports-module/reports/GoldRateHistoryReportScreen";
import EntityMasterScreen from "components/modules/admin-module/masters/EntityMasterScreen";
import BusinessUnitMasterScreen from "components/modules/admin-module/masters/BusinessUnitMasterScreen";
import UserBuAccessScreen from "components/modules/admin-module/masters/UserBuAccessScreen";
import RolePermissionScreen from "components/modules/admin-module/masters/RolePermissionScreen";
import UserManagementScreen from "components/modules/admin-module/masters/UserManagementScreen";
import KfsCalculatorScreen from "components/modules/utility-module/kfs-calculator/components/KfsCalculatorPage";

export const COMPONENT_REGISTRY: Record<string, React.ComponentType<any>> = {
  SampleMasterScreenTabbed: SampleMasterScreenTabbed,
  SampleMasterScreen: SampleMasterScreen,
  GoldRateMasterScreen: GoldRateMasterScreen,
  CustomerRegistryScreen: CustomerRegistryScreen,
  SystemConfigScreen: SystemConfigScreen,
  AddonRequestScreen: AddonRequestScreen,
  LoanMappingScreen: LoanMappingScreen,
  ClosingTransactionScreen: ClosingTransactionScreen,
  CombinedTransactionScreen: CombinedTransactionScreen,
  GlReplacementScreen: GlReplacementScreen,
  RegroupTransactionScreen: RegroupTransactionScreen,
  ApprovalDashboardScreen: ApprovalDashboardScreen,
  ReportsPlaceholderScreen: ReportsPlaceholderScreen,
  AddonSummaryReportScreen: AddonSummaryReportScreen,
  LoanMappingReportScreen: LoanMappingReportScreen,
  ClosingSettlementReportScreen: ClosingSettlementReportScreen,
  CombinedTxnReportScreen: CombinedTxnReportScreen,
  AuditTrailReportScreen: AuditTrailReportScreen,
  GlReplacementReportScreen: GlReplacementReportScreen,
  GoldRateHistoryReportScreen: GoldRateHistoryReportScreen,
  EntityMasterScreen: EntityMasterScreen,
  BusinessUnitMasterScreen: BusinessUnitMasterScreen,
  UserBuAccessScreen: UserBuAccessScreen,
  RolePermissionScreen: RolePermissionScreen,
  UserManagementScreen: UserManagementScreen,
  KfsCalculatorScreen: KfsCalculatorScreen,
};